export const SIGNED_IN = 'auth.signed-in'
export const SIGNED_OUT = 'auth.signed-out'
export const CONTINUE_SESSION = 'auth.continue-session'
export const AUTH_INITIALIZED = 'auth.initialized'
export const PROFILE_UPDATED = 'auth.profile-updated'
export const AUTH_PROCESS_ERROR = 'auth.process-error'
export const AUTH_BOOTSTRAP_FAILED = 'auth.bootstrap-failed'
export const USER_SWITCH_STARTED = 'auth.user-switch.started'
export const USER_SWITCH_FINISHED = 'auth.user-switch.finished'

//TODO This is not *really* part of auth, more part of app?
export const START_MANAGING_ORG = 'auth.organization.start-managing'
export const CURRENT_ORG_UPDATED = 'auth.organization.update-current'

export const authInitialized = (user, organization, profile) => ({
  type: AUTH_INITIALIZED,
  payload: { user, organization, profile },
})

export const profileUpdated = profile => ({
  type: PROFILE_UPDATED,
  payload: { profile },
})

export const signedIn = user => ({
  type: SIGNED_IN,
  payload: { user },
})

export const continueSession = user => ({
  type: CONTINUE_SESSION,
  payload: { user },
})

export const signedOut = () => ({ type: SIGNED_OUT })

// Kiosk start/exit signs one Cognito user out and the next one in; both Hub events reach the
// app before the saga can finish, so the gate needs to know a switch is in progress.
export const userSwitchStarted = () => ({ type: USER_SWITCH_STARTED })

export const userSwitchFinished = () => ({ type: USER_SWITCH_FINISHED })

export const authProcessError = (message, data = undefined, { shouldSignOut = true } = {}) => ({
  type: AUTH_PROCESS_ERROR,
  payload: { message, data, shouldSignOut },
})

export const authBootstrapFailed = (message, data = undefined) => ({
  type: AUTH_BOOTSTRAP_FAILED,
  payload: { message, data },
})

export const startManagingOrg = organization => ({
  type: START_MANAGING_ORG,
  payload: { organization },
})

export const currentOrgUpdated = organization => ({
  type: CURRENT_ORG_UPDATED,
  payload: { organization },
})
